import api from '../api/axios';

export const login = async (email, password) => {
  const formData = new FormData();
  formData.append('Email', email);
  formData.append('Password', password);
  const { data } = await api.post('/login', formData);
  return data;
};

export const getLoggedInUserData = async (email) => {
  const { data } = await api.get(`/loggedinuserdata/${email}`);
  return Array.isArray(data) ? data : [];
};

export const sendPasswordResetLink = async (email) => {
  const formData = new FormData();
  formData.append('Email', email);
  formData.append('frontendUrl', window.location.origin);
  const { data } = await api.post('/sendpasswordlink', formData);
  return data;
};

export const validateResetToken = async (id, token) => {
  const { data } = await api.get(`/ResetPasswordpage/${id}/${token}`);
  return data;
};

export const changePassword = async (id, token, password) => {
  const formData = new FormData();
  formData.append('Password', password);
  const { data } = await api.post(`/Changepassword/${id}/${token}`, formData);
  return data;
};

export const changePasswordLoggedIn = async (currentPassword, newPassword) => {
  const { data } = await api.post('/account/change-password', {
    currentPassword,
    newPassword,
  });
  return data;
};
